import React, { useState, useEffect, useCallback } from 'react';
import { useUser } from '../UserContext';
import ScheduleTab from './schedule';
import MessagesTab from './messages';
import AvailabilityTab from './availability';
import ValidateTab from './validate';
import { CLINIC_API_ORIGIN } from '../config/apiOrigins';
import './clinician.css';

const API_BASE = CLINIC_API_ORIGIN;

export default function Clinician() {
  const { user, isLoadingUser } = useUser();
  const clinician_uuid = user?.clinician_uuid;
  const clinician_identifier = user?.email || clinician_uuid;
  const [tab, setTab] = useState('validate');
  const [pendingCount, setPendingCount] = useState(0);

  const fetchPendingCount = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/Clinician/validation/list`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: 'pending', limit: 500 }),
      });
      const data = await res.json();
      setPendingCount((data.items || []).length);
    } catch (e) {
      console.error('Failed to fetch pending count:', e);
    }
  }, []);

  useEffect(() => {
    fetchPendingCount();
    const id = setInterval(fetchPendingCount, 10000);
    return () => clearInterval(id);
  }, [fetchPendingCount]);

  if (isLoadingUser) return <div className="clinician-pad">Loading User...</div>;
  if (!clinician_uuid) return <div className="clinician-pad">Error: Clinician UUID not found for this user.</div>;

  return (
    <div className="clinician-app">
      <div className="HomeSample-header">
        <div className="clinician-tabs">
                 <button
            className={`HomeSample-tab ${tab === 'validate' ? 'active' : ''}`}
            onClick={() => setTab('validate')}
          >
                    {pendingCount > 0 && (
              <span className="clinician-tab-badge">{pendingCount}</span>
            )}
            Validate
    
          </button>

   
          <button
            className={`HomeSample-tab ${tab === 'schedule' ? 'active' : ''}`}
            onClick={() => setTab('schedule')}
          >
            Schedule
          </button>
          <button
            className={`HomeSample-tab ${tab === 'availability' ? 'active' : ''}`}
            onClick={() => setTab('availability')}
          >
            Availability
          </button>
        </div>
      </div>

      <main className="clinician-main-view">
        {tab === 'schedule' && (
          <ScheduleTab
            clinician_uuid={clinician_uuid}
            clinician_identifier={clinician_identifier}
            apiBase={API_BASE}
          />
        )}
        {tab === 'messages' && (
          <MessagesTab
            clinician_uuid={clinician_uuid}
            clinician_identifier={clinician_identifier}
            apiBase={API_BASE}
          />
        )}
        {tab === 'availability' && (
          <AvailabilityTab
            clinician_uuid={clinician_uuid}
            apiBase={API_BASE}
          />
        )}
        {tab === 'validate' && (
          <ValidateTab
            clinician_uuid={clinician_uuid}
            apiBase={API_BASE}
          />
        )}
      </main>
    </div>
  );
}
